"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayWhenGreaterThanEqual = exports.DisplayWhenGreaterThan = exports.DisplayWhenLessThanEqual = exports.DisplayWhenLessThan = exports.DisplayWhen = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const hidden = (visibility) => {
    if (visibility) {
        return `visibility: hidden;`;
    }
    return `display: none;`;
};
const Styled = styled_components_1.default.div `
	${(p) => {
    if (p.$hidden === true) {
        return hidden(p.$visibility);
    }
    /**
     * Add/Subtract 0.05 to ensure the value passed gets rendered
     */
    const adjustmentWidth = () => {
        if (p.$hideOnEqual) {
            return 0;
        }
        return p.$type === "max-width" ? -0.05 : 0.05;
    };
    const mq = `@media (${p.$type}: ${p.$width + adjustmentWidth()}px) {
                ${hidden(p.$visibility)}
            }`;
    return mq;
}};
`;
const DisplayWhen = ({ type, width, children, visibility, hidden, hideOnEqual, }) => {
    const $type = type === "min" ? "min-width" : "max-width";
    return ((0, jsx_runtime_1.jsx)(Styled, Object.assign({ className: "display-when", "$type": $type, "$hidden": hidden, "$visibility": visibility, "$width": width, "$hideOnEqual": hideOnEqual }, { children: children })));
};
exports.DisplayWhen = DisplayWhen;
const DisplayWhenLessThan = (_a) => {
    var props = __rest(_a, []);
    return (0, jsx_runtime_1.jsx)(exports.DisplayWhen, Object.assign({}, props, { type: "min", hideOnEqual: true }));
};
exports.DisplayWhenLessThan = DisplayWhenLessThan;
const DisplayWhenLessThanEqual = (_a) => {
    var props = __rest(_a, []);
    return (0, jsx_runtime_1.jsx)(exports.DisplayWhen, Object.assign({}, props, { type: "min" }));
};
exports.DisplayWhenLessThanEqual = DisplayWhenLessThanEqual;
const DisplayWhenGreaterThan = (_a) => {
    var props = __rest(_a, []);
    return (0, jsx_runtime_1.jsx)(exports.DisplayWhen, Object.assign({}, props, { type: "max", hideOnEqual: true }));
};
exports.DisplayWhenGreaterThan = DisplayWhenGreaterThan;
const DisplayWhenGreaterThanEqual = (_a) => {
    var props = __rest(_a, []);
    return (0, jsx_runtime_1.jsx)(exports.DisplayWhen, Object.assign({}, props, { type: "max" }));
};
exports.DisplayWhenGreaterThanEqual = DisplayWhenGreaterThanEqual;
//# sourceMappingURL=DisplayWhen.js.map